/**
 * Shared NC Year → Display Label mapping for all schools
 * 
 * NC Year Codes by school:
 *   Bani Hajer:  -1=Pre-School, 0=Reception, 1-6=Year 1-6
 *   MOQ Senior:  7-13=Year 7-13
 *   MOQ Prep:    15-22 (offset -16 → Pre-School through Year 6)
 *   Qetaifan:    26-33 (offset -27 → Pre-School through Year 6)
 *   Boys School: 34-41 (34=Pre-School, 35=Reception, 36-41=Year 1-6)
 *   Girls School: same as Bani Hajer (-1 to 11)
 */

// Boys School NC year mapping
const BOYS_NC_MAP = {
  '34': 'Pre-School',
  '35': 'Reception',
  '36': 'Year 1',
  '37': 'Year 2',
  '38': 'Year 3',
  '39': 'Year 4',
  '40': 'Year 5',
  '41': 'Year 6',
};

// Qetaifan NC year mapping
const QETAIFAN_NC_MAP = {
  '26': 'Pre-School',
  '27': 'Reception',
  '28': 'Year 1',
  '29': 'Year 2',
  '30': 'Year 3',
  '31': 'Year 4',
  '32': 'Year 5',
  '33': 'Year 6',
};

// MOQ Prep NC year mapping
const MOQ_PREP_NC_MAP = {
  '15': 'Pre-School',
  '16': 'Reception',
  '17': 'Year 1',
  '18': 'Year 2',
  '19': 'Year 3',
  '20': 'Year 4',
  '21': 'Year 5',
  '22': 'Year 6',
};

/**
 * Convert an NC year code to a human-readable label
 * Works for all schools (Bani Hajer, Boys, Girls, Qetaifan, MOQ)
 */
export function getYearLabel(ncYear) {
  const y = String(ncYear);
  
  // Boys School (34-41)
  if (BOYS_NC_MAP[y]) return BOYS_NC_MAP[y];
  
  // Qetaifan (26-33)
  if (QETAIFAN_NC_MAP[y]) return QETAIFAN_NC_MAP[y];
  
  // MOQ Prep (15-22)
  if (MOQ_PREP_NC_MAP[y]) return MOQ_PREP_NC_MAP[y];
  
  // Bani Hajer / Girls / standard
  if (y === '-1') return 'Pre-School';
  if (y === '0') return 'Reception';
  
  const num = parseInt(y, 10);
  if (!isNaN(num) && num >= 1 && num <= 13) return `Year ${num}`;
  
  return `Year ${y}`;
}

/**
 * Get the year group name from an NC year code (alias)
 */
export function getStudentYearGroup(ncYear) {
  return getYearLabel(ncYear);
}

/**
 * Get the "physical" year number from an NC year (for difficulty levels, etc.)
 * Returns the actual year number (e.g., NC 38 → 3, NC 3 → 3)
 */
export function getPhysicalYear(ncYear) {
  const num = parseInt(ncYear, 10);
  if (isNaN(num)) return 1;
  
  // Boys School: 34=PS(-1), 35=R(0), 36-41=Y1-Y6
  if (num >= 36 && num <= 41) return num - 35;
  if (num === 35) return 0;
  if (num === 34) return -1;
  
  // Qetaifan: 26=PS, 27=R, 28-33=Y1-Y6
  if (num >= 28 && num <= 33) return num - 27;
  if (num === 27) return 0;
  if (num === 26) return -1;
  
  // MOQ Prep: 15=PS, 16=R, 17-22=Y1-Y6
  if (num >= 17 && num <= 22) return num - 16;
  if (num === 16) return 0;
  if (num === 15) return -1;
  
  // Standard (Bani Hajer, Girls, MOQ Senior)
  return num;
}

export default getYearLabel;
